<template>
  <ServiceLayout
    icon="notext-starroad.png"
    title="StarRoad"
    description="Layanan yang menggunakan mobil sebagai transportasi jalan-jalan anda yang dikemudikan oleh guiders ke negara atau kota manapun yang anda inginkan dengan menyesuaikan kemampuan guiders dengan ketentuan yang berlaku di negara tertentu. (Biaya sewa mobil tidak termasuk)."
    :extra_hour="2"
    :tariffs="starroad_tariffs"
    :lists="starroad_list"
  />
</template>

<script>
import ServiceLayout from '@/components/ServiceLayout'

export default {
  name: 'StarRoad',
  components: {
    'ServiceLayout': ServiceLayout
  },
  data () {
    return {
      starroad_list: [
        /* {
          icon: 'users',
          icon_position: 'left',
          title: 'Kapasitas',
          subtitle: 'Cocok untuk anda yang memiliki keluarga, teman, atau sahabat dekat yang ingin bepergian dengan menyesuaikan kapasitas mobil dan kemampuan berkendara Guiders di negara tertentu.'
        }, */
        {
          icon: 'waktu-fleksibel.png',
          icon_position: 'right',
          title: 'Flexibilitas',
          subtitle: 'Dengan layanan STARROAD yang anda pilih, anda bebas bepergian ditemani dan di kemudikan oleh Guiders ke negara atau kota kemana pun anda mau dengan menyesuaikan kemampuan Guiders dan ketentuan yang berlaku di negara tertentu.'
        },
        {
          icon: 'tarif-pasti.png',
          icon_position: 'left',
          title: 'Tarif Pasti',
          subtitle: 'Kami memberikan tarif pasti kepada setiap Member STARGUIDES dan tidak perlu khawatir tawar menawar lagi karna biaya nya sudah pasti.'
        },
        {
          icon: 'friendly.png',
          icon_position: 'right',
          title: 'Friendly',
          subtitle: 'Guiders kami akan selalu memberikan pelayanan dan sikap yang terbaik bagi semua member STARGUIDES.'
        },
        {
          icon: 'aman-nyaman.png',
          icon_position: 'left',
          title: 'Aman dan Nyaman',
          subtitle: 'Guiders kami akan selalu berusaha untuk memberikan keamanan dan kenyamanan selama bepergian di kota-kota yang anda kunjungi dengan STARROAD.'
        },
        {
          icon: 'kemudahan-pembayaran.png',
          icon_position: 'right',
          title: 'Kemudahan Pembayaran',
          subtitle: 'Tidak perlu khawatir soal uang kembalian atau uang tunai, dengan, kartu kredit, layanan kami kini semakin praktis.'
        }
      ],
      starroad_tariffs: [
        'Rp. 3.113.600* per hari (Eropa, Jepang, Turki, Korea, Tiongkok)',
        'Rp. 776.250* per hari (Malaysia)'
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Service/StarRoad.vue